<template>
  <div>
    <section class="main-content">

        <!-- <div class="inner-banner">
            <div class="container">
                <h3>我的收藏</h3>
            </div>
        </div> -->

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>我的收藏</span></h3>
                            <div class="articles-items">

                                <form class="form-inline">
                                    <label class="mr-sm-2" for="inlineFormCustomSelect">挑選歌曲</label>
                                    <label class="mr-sm-2" for="inlineFormCustomSelect">語文</label>
                                    <select class="custom-select mb-2 mr-sm-2 mb-sm-0" v-model="chooseLang">
                                        <option value="" selected>全部</option>
                                        <option v-for="option in lang" v-bind:value="option.id">
                                            {{option.title}}
                                        </option>
                                    </select>
                                    <label class="mr-sm-2" for="inlineFormCustomSelect">節奏</label>
                                    <select class="custom-select mb-2 mr-sm-2 mb-sm-0" v-model="chooseTempo">
                                        <option value="" selected>節奏</option>
                                        <option v-for="option in tempo" v-bind:value="option.id">
                                            {{option.title}}
                                        </option>
                                    </select>
                                    <input type="text" class="form-control" v-model="keyword" placeholder="歌曲名稱 / 作者"/>
                                </form>
                                <div class="song-list">
                                  <div class="song-item song-mainitem row">
                                      <div class="col-md-4">歌曲</div>
                                      <div class="col-md-4">歌者</div>
                                      <div class="col-xl-3 col-md-2">刊登時間</div>
                                      <div class="col-xl-1 col-md-2"></div>
                                  </div>
                                    <div class="song-item row" v-for="(row, index) in songdata">
                                        <div class="col-md-4 song-item-name">{{row.title}}</div>
                                        <div class="col-md-4 song-item-author">{{row.author}}</div>
                                        <div class="col-xl-3 col-md-2 col-8 song-item-date">{{row.created_at.substr(0,10)}}</div>
                                        <div class="col-xl-1 col-md-2 col-4 text-center song-item-btn">
                                          <a class="btn-song-detail" :href="'/songs/'+row.id">聆聽去</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'collection',
  data () {
    return {
      uri: this.$store.getters.getUri,
      token: this.$store.getters.getToken,
      saveSongData: Object,
      songdata: Object,
      chooseLang: '',
      chooseTempo: '',
      songQty: 0,
      keyword: ''
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getSongTagLang',
      tempo: 'getSongTagTempo'
    })
  },
  mounted: function () {
    this.loadCollection()
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    loadCollection () {
      let self = this
      if (this.token !== '') {
        let uploadData = Qs.stringify({
          token: this.token
        })
        this.$http.post(this.uri + 'Song/song_collection', uploadData).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            self.songdata = data.songs
            self.saveSongData = data.songs
            return data.songs
          } else {
            console.log('下載歌曲失敗')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        return false
      }
    },
    filterSong () {
      let lang = this.chooseLang
      let tempo = this.chooseTempo
      this.songdata = this.saveSongData
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_1.indexOf(lang) >= 0
        })
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_3.indexOf(tempo) >= 0
        })
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲')
      }
    },
    filterKeyword () {
      let keyword = this.keyword
      if (keyword !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.author.indexOf(keyword) >= 0 || value.title.indexOf(keyword) >= 0
        })
      } else {
        this.songdata = this.saveSongData
      }
    }
  },
  watch: {
    chooseLang: {
      handler: function (val, oldVal) {
        this.filterSong()
      }
    },
    chooseTempo: {
      handler: function (val, oldVal) {
        this.filterSong()
      }
    },
    keyword: {
      handler: function (val, oldVal) {
        this.filterKeyword()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Collection.vue?39ec0ac3